import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PurposeStatementDto } from 'src/app/domain/models/dto/purpose-statement.dto';
import { ResponseObjectModel } from 'src/app/domain/models/response-object.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PurposeStatementService {

  constructor(private http: HttpClient) { }

  get(id: number) {
    return this.http.get<ResponseObjectModel<PurposeStatementDto>>(`${environment.API_BASE_URL}/v1/purpose-statements/${id}`);
  }
}
